<ng-container *ngIf="pickingList">
{{pickingList?.status_map[event]?.date}}
{{pickingList?.status_map[event]?.initials ? '('+pickingList?.status_map[event]?.initials+')' : '-'}}
</ng-container>
